<div class="relative min-h-screen flex flex-col">
    <!--Navbar-->
    <app-navbar></app-navbar>
    <!-- Top Banner Section Start -->
    <div class="flex-grow">
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/banners/doctor-banner-1.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">All Doctors</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->

        <!-- Doctor List Section Start -->
        <div class="container mx-auto p-10 md:mb-5 xl:mb-[100px]">
            <!-- Mat Spinner  -->
            <ngx-spinner bdColor="rgba(256, 256, 256, 0.5)" size="default" color="#6eabc6" type="ball-spin-fade"
                [fullScreen]="true">
                <p style="color: black"> Fetching doctors... </p>
            </ngx-spinner>
            <div class="mb-[50px] box_title">
                <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">Our Team</span>
                <h2 class="title mt-0 mb-[20px] font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76] max-w-[100%] leading-[1.2em]">Our Doctors</h2>
            </div>
            <!-- <div class="doctors-sec md:custom-margin" *ngIf="doctors && doctors.length > 0">
                <div class="mt-10 flex flex-wrap justify-center">
                    <div class="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-8"
                        *ngFor="let doctor of doctors;">
                        <div class="w-full rounded-[30px] overflow-hidden shadow-lg mx-1" id="doctor-profile-card">
                            <div class="doctor-img-wrapper">
                                <div class="doctor-img">
                                    <img class="w-full h-[450px] sm:h-[400px] rounded-[30px] object-cover object-top"
                                        [src]="doctor.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doctor.image : '/assets/images/icons/doctor-default-img.png'" alt="{{doctor.title}}">
                                </div>
                            </div>
                            <div class="pt-[22px] doctor-details-content">
                                <div class="px-6 doctor-details-inner">
                                    <div class="inline-block text-[12px] leading-[28px] uppercase pl-[15px] relative tracking-2 doctor-position">{{doctor.specialty}}</div>
                                    <h3 class="text-[20px] leading-[24px] mt-2 text-[#010d27] doctor-title">{{doctor.title}}</h3>
                                </div>
                                <div class="px-6 pb-2">
                                    <button (click)="bookNow(doctor)"
                                        class="book-now w-full rounded-md borderfont-bold uppercase text-xs px-4 py-3 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2 cursor-pointer">
                                        View Doctor Details</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div *ngIf="doctors && doctors.length >0">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 md:col-span-6 xl:col-span-4" *ngFor="let doctor of paginatedDoctors">
                        <div class="doctor-card p-2">
                            <div
                                class="doctor-details-container grid grid-cols-12 px-[29px] pt-[29px] pb-[30px] rounded-top-5px border border-[#e8e8e8] rounded-t-[5px]">
                                <div class="doctor-img col-span-4">
                                    <a href="#"
                                        class="inline-block w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] rounded-full overflow-hidden">
                                        <img [src]="doctor.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doctor.image : '/assets/images/icons/doctor-default-img.png'"
                                            alt="" class="w-[100%] h-[100%] object-cover">
                                    </a>
                                </div>
                                <div class="doctor-description col-span-8">
                                    <div class="doctor-description-inner ml-[10px]">
                                        <div class="doctor-speciality flex">
                                            <div
                                                class="speciality-title py-[3px] px-[14px] text-[14px] border border-[#e8e8e8] rounded-[5px] text-[#45a6d1]">
                                                {{doctor.specialty}}
                                            </div>
                                            <!-- <div
                                                class="doctor-rating py-[3px] px-[16px] bg-[#112c76] text-white rounded-[5px] ml-[10px] text-[14px]">
                                                <span>(124)</span>
                                            </div> -->
                                        </div>
                                        <div
                                            class="doctor-title text-18px md:text-[20px] lg:text-[24px] my-[10px] overflow-hidden text-[#112c76] font-semibold">
                                            <h4 class="font-medium mb-2">{{doctor.title}}</h4>
                                        </div>
                                        <div
                                            class="doctor-expertise flex items-center text-[14px] text-[#45a6d1] flex text-[14px] text-[#858585]">
                                            <span class="material-symbols-outlined overflow-hidden text-[#112c76b5] font-semibold">
                                                school
                                            </span>
                                            <span
                                                class="text-[16px] text-[#45a6d1] relative py-[0.5em] pl-[1em] max-w-[90%] whitespace-nowrap text-ellipsis overflow-hidden">
                                                {{doctor.qualification}}</span>
                                        </div>
                                        <div
                                            class="doctor-expertise flex items-center text-[14px] text-[#45a6d1] mb-[10px] flex text-[14px] mb-[10px] text-[#858585]">
                                            <span class="material-symbols-outlined text-[#112c76b5] font-bold">
                                                nutrition
                                            </span>
                                            <span
                                                class="text-[16px] text-[#45a6d1] relative py-[0.5em] pl-[1em] max-w-[90%] whitespace-nowrap text-ellipsis overflow-hidden">
                                                {{doctor.designation}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="readmore-btn">
                                <button
                                    class="btn w-[100%] text-[16px] font-bold text-[#112c76] rounded-b-[5px] bg-[#45a6d13b] py-[5px] px-[35px] inline-flex text-center leading-[40px] justify-center hover:bg-[#112c76] hover:text-white ease-in duration-300 cursor-pointer"
                                    (click)="bookNow(doctor)">
                                    View Doctor Details 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="flex justify-center mt-4">
                    <button
                      class="px-4 py-2 mr-2 text-white bg-blue-500 rounded-lg"
                      (click)="previousPage()"
                      [disabled]="currentPage === 1"
                    >
                      Previous
                    </button>                                                                                                                                                                                                                                                                                              
                    <span class="px-4 py-2">{{ currentPage }} of {{ totalPages }}</span>
                    <button
                      class="px-4 py-2 ml-2 text-white bg-blue-500 rounded-lg"
                      (click)="nextPage()"
                      [disabled]="currentPage === totalPages"
                    >
                      Next
                    </button>
                  </div> -->
                  <div class="flex justify-center mt-5" *ngIf="doctors.length > pageSize">
                    <mat-paginator #paginator
                        class="demo-paginator"
                        (page)="handlePageEvent($event)"
                        [length]="length"
                        [pageSize]="pageSize"
                        [disabled]="disabled"
                        [showFirstLastButtons]="showFirstLastButtons"
                        [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
                        [hidePageSize]="hidePageSize"
                        [pageIndex]="pageIndex"
                        aria-label="Select page">
                    </mat-paginator>
                  </div>
            </div>
            <div class="custom-margin p-10 custom-border flex justify-center items-center" *ngIf="doctors && doctors.length === 0">
                <div class="flex justify-center">
                    <p class="text-[#667ac3] text-center">
                        "Sorry, but we couldn't find any doctors specializing in this field at the moment. Please
                        consider broadening your search criteria or checking back later.<br> If you have any specific
                        questions or need assistance, feel free to contact our support team. We're here to help!"
                    </p>
                </div>
            </div>

        </div>
        <!-- Doctor List Section Start -->
    </div>

    <!-- Footer  -->
    <app-message></app-message>
    <app-footer></app-footer>
</div>